/**
 * Almacen del token de acceso, solo en memoria (INV-8, FR-STORE-7,
 * spec/05-security.md §4.2). El token vive en una variable de closure,
 * inaccesible desde fuera de las funciones devueltas: nunca en ambito
 * global, nunca en localStorage/IndexedDB/cache del service worker, y por
 * tanto nunca capturado accidentalmente por JSON.stringify de otro objeto.
 */

export interface StoredToken {
  readonly accessToken: string;
  readonly expiresAt: number; // epoch ms
}

export interface TokenStore {
  set(token: StoredToken): void;
  get(): StoredToken | undefined;
  isExpired(now?: number): boolean;
  clear(): void;
}

/** Fabrica: cada llamada crea un closure propio. No hay estado de modulo compartido. */
export function createInMemoryTokenStore(): TokenStore {
  let token: StoredToken | undefined;

  return {
    set(t: StoredToken): void {
      token = { accessToken: t.accessToken, expiresAt: t.expiresAt };
    },
    get(): StoredToken | undefined {
      return token;
    },
    isExpired(now: number = Date.now()): boolean {
      return !token || now >= token.expiresAt;
    },
    clear(): void {
      token = undefined;
    },
  };
}
